// extracted by mini-css-extract-plugin
export var container = "NavigationItem-module--container--3NP9U";
export var disabled = "NavigationItem-module--disabled--1C2r9";
export var prev = "NavigationItem-module--prev--2IkzB";
export var next = "NavigationItem-module--next--3XIEY";